module.exports = __webpack_public_path__ + "img/button_right.daf85d95.png";